export default __webpack_public_path__ + "d3e9bc5cdbf9b10413f4ae576ea3a8ac.svg";